import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './services/auth.service';

/** Holds a staff member whose password is under the floor out of the CMS
 *  until they rotate it. Sits on the layout, so it covers every protected
 *  page; the flag is read from storage, so a page refresh cannot skip it. */
export const rotationGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  return auth.mustRotatePassword()
    ? router.createUrlTree(['/first-sign-in'])
    : true;
};

/** The mirror: the rotation screen exists only while a rotation is actually
 *  pending, so a user who has already rotated cannot sit on it. */
export const rotationPendingGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  return auth.mustRotatePassword()
    ? true
    : router.createUrlTree([auth.homeUrl()]);
};
